import React, { useCallback, useLayoutEffect, useRef, useState } from "react";
import "./QuotationPostCard.scss";
import QuotationImage1 from "./QuotationImage1";
import { ParagraphMomento } from "@tumomento/ui";
import MomentoIC from "@/components/ui/MomentoIC";
import ArrowDown from "./ArrowDown";
import Otto from "@/components/ui/Otto";
import { LANDING_PAGE } from "@/constants";
const CardMode = ({
  asModal,
  onClose,
}: {
  asModal?: boolean;
  onClose?: () => void;
}) => {
  return (
    <div
      className={`momento-blog-quotation flex col px-6 pt-12 pb-8${
        asModal ? " as-modal" : ""
      }`}
    >
      {asModal && onClose && (
        <button className="close-btn" onClick={onClose}>
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8 8L24 24"
              stroke="white"
              strokeWidth="2.66667"
              strokeLinecap="round"
            />
            <path
              d="M24 8L8 24"
              stroke="white"
              strokeWidth="2.66667"
              strokeLinecap="round"
            />
          </svg>
        </button>
      )}
      <div className="quotation-image-1-container flex col center-content">
        <QuotationImage1 />
      </div>
      <div className="flex col g-2 mt-5 mb-2">
        <ParagraphMomento
          fontFamily="beatrice"
          typography="beatrice-1"
          align="center"
        >
          ¿Quieres un seguro de auto que sí te cuide de verdad?
        </ParagraphMomento>
        <ParagraphMomento align="center" color="basicWhite">
          Todo en línea. Reclamos más rápidos. <br />
          Servicio inmejorable.
        </ParagraphMomento>
      </div>
      <button
        className="quote-btn momento-text heading-s backgroundInverse"
        onClick={() =>
          window.open(
            `${LANDING_PAGE}/form/cotizacion?clearData=true`,
            "_blank"
          )
        }
      >
        Cotiza en minutos
      </button>
    </div>
  );
};
const MobileMode = () => {
  const canScrollRef = useRef(true);
  const thirdPartOfScreen = window.innerHeight * 0.33;
  const [showCard, setShowCard] = useState(false);
  const [bannerMode, setBannerMode] = useState<"hide" | "on-top" | "">(
    "on-top"
  );

  const onScrollHandler = useCallback(() => {
    if (showCard) return;
    const y = window.scrollY;
    if (y >= thirdPartOfScreen) setBannerMode("");
    else if (bannerMode !== "hide") setBannerMode("on-top");
  }, [showCard]);
  const disableScrollIos = (ev: Event) => {
    if (!canScrollRef.current) return ev.preventDefault();
  };
  const showCardHandler = () => {
    if (bannerMode == "on-top") return;
    setShowCard(true);
    document.body.style.overflowY = "hidden";
    canScrollRef.current = false;
    setBannerMode("hide");
  };
  useLayoutEffect(() => {
    addEventListener("scroll", onScrollHandler);
    const isIphone = navigator.userAgent.toLowerCase().includes("iphone");
    if (isIphone) {
      addEventListener("touchmove", disableScrollIos, { passive: false });
    }
    return () => {
      removeEventListener("scroll", onScrollHandler);
      if (isIphone) {
        removeEventListener("touchmove", disableScrollIos);
      }
    };
  }, []);
  return (
    <>
      <div
        onClick={showCardHandler}
        className={`momento-quotation-banner flex row align-center justify-center px-2 ${bannerMode}`}
      >
        <Otto className="otto" />
        <ArrowDown color="#FFF" className="pe-1 arrow" />
        <div className="flex row align-center justify-space-evenly w100">
          <a
            className="momento-text heading-s basicWhite underlined"
            onClick={showCardHandler}
          >
            Haz clic aquí
          </a>
          <ParagraphMomento color="basicWhite">para conocer</ParagraphMomento>
          <MomentoIC />
        </div>
      </div>
      {showCard && (
        <div className="quote-modal">
          <CardMode
            asModal
            onClose={() => {
              setShowCard(false);
              document.body.style.overflowY = "unset";
              canScrollRef.current = true;
              setBannerMode("on-top");
            }}
          />
        </div>
      )}
    </>
  );
};
export const QuotationPostCard = ({ mobile }: { mobile?: boolean }) => {
  return mobile ? <MobileMode /> : <CardMode />;
};
